import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialNoticesState } from "./notices.types";
import { NoticesActions } from ".";
import {
  CLEAR_NOTICES_STATE,
  FETCH_NOTICES_LIST_FAILED,
  FETCH_NOTICES_LIST_PROGRESS,
  FETCH_NOTICES_LIST_SUCCESS,
} from "./noticesActions";

export const noticesReducer = (
  state: IStoreState["tasks"]["notices"] = initialNoticesState,
  action: NoticesActions
) => {
  switch (action.type) {
    case FETCH_NOTICES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_NOTICES_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = list;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_NOTICES_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
        draftState.totalRecords = 0;
      });
      return newState;
    }
    case CLEAR_NOTICES_STATE: {
      return initialNoticesState;
    }

    default: {
      return state;
    }
  }
};
